<template>
  <v-autocomplete
    v-model="selectedAirline"
    :items="airlines"
    persistent-hint
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    placeholder="Airline"
    prepend-icon="flight"
    browser-autocomplete="off"
    @change="selectAirline()"
    :disabled="disabled"
    clearable
    append-icon=""
    clear-icon="cancel"
  >
    <template v-slot:append-outer>
      <v-slide-x-reverse-transition
        mode="out-in"
      >
      </v-slide-x-reverse-transition>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  created(){
    if (this.setAirline!=null&&this.setAirline!=""){
      this.selectedAirline = this.setAirline;
      this.selectAirline();
      setTimeout(() => {
        if (this.airlines.length>0){
          this.selectedAirline = this.getAirlineCodeWithName;
        }
      }, 2000);
    }
  },
  props:["airlines","setAirline","disabled",],
  data(){
    return {
      selectedAirline:null,
      isLoading:false,
      search:null,
      emitters:{
        emSelectedAirline:"emSelectedAirline",
      },
    }
  },
  computed:{
    getAirlineCodeWithName(){
      let linq = new this.$linq(this.airlines);
      let al = linq.where(a=>a.indexOf(this.setAirline + " - ")==0).toArray()[0];
      let airlineFullText = al;
      return airlineFullText;
    },
    getCodeOfSelectedAirline(){
      let code = "--";
      try{
        code = this.selectedAirline.split("-")[0];
      }catch(err){
        code = "--";
      }
      return code;
    }
  },
  methods:{
    selectAirline(){
      this.$emit(this.emitters.emSelectedAirline,this.getCodeOfSelectedAirline);
    },    
  }
}
</script>

<style>

</style>